// MAIN SITE
export const ROOT_ACCENT_COLOR = "#8cc041";

// REGISTER PAGE/SUBPAGES
export const ACCENT_COLOR = "#17a799"; //"#5bc3b3";
export const BG_DARK_COLOR = "#201f25";
export const BG_DARK_TEXT = "rgba(255,255,255,1)";
export const BG_LIGHT_COLOR = "rgb(255,255,255)";
export const BG_LIGHT_TEXT = "rgb(31, 31, 36)";
